import {
  Button,
  Card,
  Group,
  ScrollArea,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import React from "react";
import { HiArrowRight, HiCamera } from "react-icons/hi";
import GeneralGallery from "../generalGallery/GeneralGallery";
import AppCard from "../common/AppCard";
import { useNavigate } from "react-router-dom";

export default function LastUploadedCard(props: { cardClassName?: string }) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);
  const navigate = useNavigate();

  const renderContent = () => {
    if (isMobile) {
      return <GeneralGallery />;
    }

    return (
      <ScrollArea h={"100%"} type="auto" offsetScrollbars scrollHideDelay={500}>
        <GeneralGallery />
      </ScrollArea>
    );
  };

  return (
    <AppCard className={props?.cardClassName ?? ""}>
      <Card.Section withBorder inheritPadding py="xs">
        <Group justify="space-between">
          <Group className="flex flex-row justify-start items-center gap-2">
            <HiCamera></HiCamera>
            <Text fw={500}>Last uploaded</Text>
          </Group>

          {/*<Menu withinPortal position="bottom-end" shadow="sm">
            <Menu.Target>
              <ActionIcon variant="subtle" color="gray">
                <HiDotsVertical size={16} />
              </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Item leftSection={<HiEye size={14} />}>View all</Menu.Item>
              <Menu.Item leftSection={<HiTrash size={14} />} color="red">
                Delete section
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>*/}

          <Group className="flex flex-row justify-end items-center gap-2">
            <Button
              rightSection={<HiArrowRight />}
              variant="subtle"
              onClick={() => {
                navigate("/timeline");
              }}
            >
              {isMobile ? "Timeline" : "View in Timeline"}
            </Button>
          </Group>
        </Group>
      </Card.Section>

      {/* <Text mt="sm" c="dimmed" size="sm">
        <Text span inherit c="var(--mantine-color-anchor)">
          200+ images uploaded
        </Text>{" "}
        since last visit, review them to select which one should be added to
        your gallery
      </Text> */}

      {/* <Card.Section
        mx="0"
        my="0"
        h={!isMobile ? "calc(100vh - 16rem)" : "100%"}
      >
        {renderContent()}
      </Card.Section> */}

      <Card.Section mx="0" my="0" h={"100%"} className="h-full overflow-auto min-h-[20rem]">
        {renderContent()}
      </Card.Section>
    </AppCard>
  );
}
